"use client";
import { jsxs as e, jsx as c } from "react/jsx-runtime";
import r from "clsx";
import p from "next/image";
import { memo as i, forwardRef as d } from "react";
import { Box as a } from "../../base/Base.js";
import '../../../assets/AttachPhotoBlock.css';const k = "_attach_block_1dnr7_1", N = "_inner_1dnr7_19", f = "_top_1dnr7_25", b = "_top__content_1dnr7_29", g = "_icon_1dnr7_32", B = "_attach_1dnr7_1", x = "_link_1dnr7_41", A = "_bottom_1dnr7_61", t = {
  attach_block: k,
  inner: N,
  top: f,
  top__content: b,
  icon: g,
  attach: B,
  link: x,
  bottom: A
}, P = ({
  textInstrustions: o,
  onClickInstruction: n,
  textUploadLink: l,
  footerComponents: s,
  children: _,
  ...m
}, h) => /* @__PURE__ */ c(a, { className: t.attach_block, ref: h, ...m, children: /* @__PURE__ */ e(a, { gap: 0, className: t.inner, children: [
  /* @__PURE__ */ e(a, { gap: 20, center: !0, className: t.top, children: [
    /* @__PURE__ */ e(a, { gap: 20, center: !0, className: t.top__content, children: [
      /* @__PURE__ */ c(
        "span",
        {
          className: r("material-icons", t.icon),
          "data-icon": "attach_file"
        }
      ),
      _
    ] }),
    n && o && /* @__PURE__ */ c("span", { className: t.link, onClick: n, children: o })
  ] }),
  s
] }) }), y = i(
  d(
    P
  )
);
y.displayName = "AttachPhotoBlock";
const j = i(
  ({ icon: o, text: n, onClick: l, ...s }) => /* @__PURE__ */ e(a, { gap: 8, className: t.bottom, onClick: l, ...s, children: [
    typeof o == "string" ? /* @__PURE__ */ c(
      "span",
      {
        className: r("material-icons", t.icon),
        "data-icon": o
      }
    ) : /* @__PURE__ */ c(
      p,
      {
        src: o,
        alt: "icon",
        width: 32,
        height: 32,
        className: t.icon
      }
    ),
    /* @__PURE__ */ c("span", { className: t.link, children: n })
  ] })
);
j.displayName = "AttachPhotoBlockFooter";
export {
  y as AttachPhotoBlock,
  j as AttachPhotoBlockFooter
};
